// Vorschau der Rabatt-Rechnung aus backend/second_life_rabatt.py.
//
// 🔴 Massgeblich ist das Backend (Decimal). Diese Fassung rechnet nur die
// Vorschau in der Karte — ganzzahlig in Cent und Zehntelprozent, damit sie an den
// Grenzen (x,90 · x,89 · 0,1 %) exakt dasselbe ergibt: num = aVkCent * (1000 - t)
// ist der Preis in Cent mal 1000, ohne Rundung. Gegengerechnet vom Grill
// (2026-10-04) ueber ~2,3 Mio. Wertepaare: 0 Abweichungen.

// B-Preis in Cent: A-VK x (1 - Rabatt), auf ,90 abgerundet.
export function bPreisCent(aVkCent, pctZehntel) {
  const num = aVkCent * (1000 - pctZehntel);
  return Math.floor((num - 90000) / 100000) * 100 + 90;
}

// 🔴 Die EK-Grenze gilt NETTO wie im Backend (`MWST_FAKTOR`): B-Preis / 1,19 >= EK.
// Ganzzahlig: bCent * 100 >= ekCent * 119 — keine Gleitkomma-Grenzfaelle.
export function haeltEk(bCent, ekCent) {
  return bCent * 100 >= ekCent * 119;
}

// Netto-Marge in Cent: B-Preis ohne MwSt. minus EK (wie `margin_absolute` im Sync).
export function margeNettoCent(bCent, ekCent) {
  return Math.round((bCent * 100) / 119) - ekCent;
}

// Groesster Rabatt in Zehntelprozent, dessen B-Preis den EK (netto) noch haelt.
// null, wenn schon 0 % darunter liegt (A-Produkt selbst unter EK).
export function maxRabattZehntel(aVkCent, ekCent) {
  if (!haeltEk(bPreisCent(aVkCent, 0), ekCent)) return null;
  let lo = 0;
  let hi = 999;
  while (lo < hi) {
    const mid = Math.floor((lo + hi + 1) / 2);
    if (haeltEk(bPreisCent(aVkCent, mid), ekCent)) lo = mid;
    else hi = mid - 1;
  }
  return lo;
}

// EK in Cent bekannt? 0 zaehlt als fehlend wie im Backend (`pruefe_rabatt`):
// in Shopify heisst 0 „nicht gepflegt", nicht „kostet nichts".
export const ekBekannt = (ekCent) => ekCent != null && ekCent > 0;

export const alsCent = (eur) =>
  eur == null || eur === '' || Number.isNaN(Number(eur)) ? null : Math.round(Number(eur) * 100);

// Eingabe "25", "17,5" oder "17.5" -> Zehntelprozent; null bei allem anderen.
export function eingabeZehntel(text) {
  const t = String(text ?? '').trim().replace(',', '.');
  if (!/^\d{1,2}(\.\d)?$/.test(t)) return null;
  const z = Math.round(Number(t) * 10);
  return z > 0 && z < 1000 ? z : null;
}

// 🔴 Der RUECKWEG zu `eingabeZehntel`: ein Wert von der Route in die EINZIGE
// Form, die das Feld annimmt. Beide Richtungen muessen zusammenpassen, sonst
// oeffnet das Feld in einem Fehlerzustand.
//
// **Gemessen 2026-10-13 im Browser (Regel-16-Befund B1).** Die Route liefert
// `rabatt_pct` als ZEICHENKETTE mit zwei Dezimalen (`'15.00'`).
// `String(v).replace('.', ',')` machte daraus `'15,00'` — und `eingabeZehntel`
// laesst hoechstens EINE Dezimale zu. Folge auf JEDER Karte, ohne dass jemand
// etwas getan hatte: Feld rot umrandet, `aria-invalid=true`, „Save discount"
// gesperrt, Meldung „Between 0.1 and 99.9 %, at most one decimal place."
//
// **Warum das so lange unsichtbar war:** die Jest-Proben speisten
// `rabatt_pct: 25` (Zahl) — die Zahl ueberlebt `String()` unbeschadet. Erst die
// Zeichenkette zeigt den Fehler. `feldVorbelegung` ist die Stelle, an der die
// beiden Einheiten aufeinandertreffen, und darum hier und nicht im Bauteil.
//
// `15.00 -> '15'`, `17.5 -> '17,5'`. Was das Feld nicht annehmen KANN (0, 100,
// Text, fehlend), wird `''` — leer, nicht falsch: leer ist „noch nichts
// eingegeben" und faerbt nichts rot.
export function feldVorbelegung(wert) {
  if (wert == null || wert === '') return '';
  const n = Number(wert);
  if (!Number.isFinite(n)) return '';
  const z = Math.round(n * 10);
  if (z < 1 || z > 999) return '';
  return String(z / 10).replace('.', ',');
}
